var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frame-container",class:{'min-width': _vm.isMinWidth}},[_c('ev-importFile',{attrs:{"href":"//at.alicdn.com/t/font_1078828_tpsdzarm1n.css","type":"css"}}),_vm._v(" "),_c('ev-importFile',{attrs:{"href":"//at.alicdn.com/t/font_1609215_660cdn6fzc4.css","type":"css"}}),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-748e16be","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Root.vue
// module id = null
// module chunks = 